import { batch } from 'react-redux';
import {
    requestUpdatePushApiSubscription,
    updatePushApiSubscription,
    updatePushApiSubscriptionError,
} from 'modules/push-api/actions/requestUpdatePushApiSubscription';
import { INDICATION_TYPES } from 'modules/taboola-common-frontend-modules/Indications';
import { addIndication } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { pushReportApi } from 'services/api/pushReportApi';
import { errorMessagesUtils } from 'services/utils';
import { cleanupSubscription, removeIds } from '../utils/utils';

export const successIndication = {
    message: <FormattedMessage id="subscription.save.success" defaultMessage="Subscription successfully updated" />,
    type: INDICATION_TYPES.SUCCESS,
    highlight: <FormattedMessage id="success.highlight" defaultMessage="Success!" />,
};

export const generateErrorIndication = (errorObject = {}) => ({
    message: errorMessagesUtils.getErrorMessage(errorObject),
    type: INDICATION_TYPES.ERROR,
    highlight: <FormattedMessage id="subscription.save.error.highlight" defaultMessage="Unable to save changes." />,
});

export const updateSubscription =
    ({ accountId, subscription, onError }) =>
    async dispatch => {
        const { id: subscriptionId } = subscription;
        dispatch(requestUpdatePushApiSubscription());

        const cleanedSubscription = removeIds(cleanupSubscription(subscription));

        try {
            const updateSubscriptionResponse = await pushReportApi.updatePushReport(
                accountId,
                subscriptionId,
                cleanedSubscription
            );
            batch(() => {
                dispatch(updatePushApiSubscription({ ...updateSubscriptionResponse, accountId }));
                dispatch(addIndication(successIndication));
            });
            return updateSubscriptionResponse;
        } catch (error) {
            dispatch(addIndication(generateErrorIndication(error)));
            dispatch(updatePushApiSubscriptionError(error));
            if (onError) {
                onError();
            }
            throw error;
        }
    };
